import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MenuDataService } from '../services/menu-data.service';

export const menuGuard: CanActivateFn = (route) => {
  const menuService = inject(MenuDataService);
  const router = inject(Router);

  const currentUrl = route.url.join('/');

  // Verificar si la ruta está permitida
  const isRouteAllowed = menuService.isRouteAllowed(currentUrl);

  if (!isRouteAllowed) {
    router.navigate(['/inicio']);
    return false;
  }

  return true;
};
